import { formatMoney } from '../formatting/money'

// Gridline labels only have to place a value on the scale, so they take the
// fewest digits that do it: "$120K" beside "$140K" reads with less ink than
// "$120.4K".
export const axisMoneyFormatter = (val: number): string =>
  val === 0 ? '' : formatMoney(val, 'coarse')

type OptionDataValue = string | number | Date | null | undefined

const formatValue = (v: OptionDataValue): string => {
  if (v == null) return '-'

  if (typeof v === 'string') {
    return v
  }

  // Abbreviated, not exact. The hover sits on a chart whose axis is already in
  // K and M, so an exact figure there was a units mismatch — and it is the same
  // number the year drill-down shows, now in the same words.
  if (typeof v === 'number') {
    return formatMoney(v, 'compact')
  }

  if (v instanceof Date) {
    return v.toLocaleDateString()
  }

  return '-'
}

export const tooltipMoneyFormatter = (
  val: OptionDataValue | OptionDataValue[]
): string => {
  if (Array.isArray(val)) {
    return val.map(formatValue).join(', ')
  }

  return formatValue(val)
}
